import React from "react";
import { classNames } from "@/utils";
import { CommunityTab, handleTabColors } from "./utils";

type Tab = {
  name: string;
  value: string;
};

interface Props {
  tabs: Tab[];
  activeTab: string;
  handleFilter: (value: string) => void;
}

const CommunityHeader = (props: Props) => {
  const { tabs, activeTab, handleFilter } = props;

  return (
    <div className="items-baseline justify-between md:flex">
      <h1 className="inline-block text-3xl font-bold">Communities</h1>
      <ul className="mt-2 mb-4 flex justify-start space-x-2 overflow-auto md:justify-end md:space-x-4">
        {tabs.map(({ name, value }) => (
          <li key={value}>
            <button
              onClick={() => handleFilter(value)}
              className={classNames(
                "w-max rounded-md px-3 py-2 text-sm font-medium capitalize",
                handleTabColors(value as CommunityTab, activeTab === value)
              )}
            >
              {name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommunityHeader;
